import React, { useContext, useState } from 'react';
import SearchByCode from './SearchByCode';
import SearchByCategory from './SearchByCategory';
import { Caby } from '../../models/interfaces';
import { useNavigate } from 'react-router-dom';
import { ProductsContext } from '../../context/products/ProductContext';

const SearchProductPage = () => {
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState('');
  const [activeTab, setActiveTab] = useState('code'); // 'code' or 'category'
  const { setCabys } = useContext(ProductsContext);

  const handleValueSelect = (value: Caby) => {
    //setSelectedValue(`${value.CodigoBienServicio} - ${value.DescripcionBienServicio}`);
    //alert(`Producto seleccionado: ${value.CodigoBienServicio} - ${value.DescripcionBienServicio}`);
    setCabys(value);
    navigate(-1);
  };

  const handleTab = (opcion: string, event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setActiveTab(opcion);
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Buscar Productos</h2>

      {/* Input para mostrar el valor seleccionado */}
      {/* <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Seleccione un valor"
          value={selectedValue}
          readOnly
        />
      </div> */}

      {/* Navbar para alternar entre búsquedas */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'code' ? 'active' : ''}`}
            onClick={(event) => handleTab('code', event)}
          >
            Búsqueda por Código o Descripción
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'category' ? 'active' : ''}`}
            onClick={(event) => handleTab('category', event)}
          >
            Búsqueda por Categoría
          </button>
        </li>
      </ul>

      {/* Paneles de Búsqueda */}
      {activeTab === 'code' && <SearchByCode onSelect={handleValueSelect} />}
      {activeTab === 'category' && <SearchByCategory onSelect={handleValueSelect} />}
      <div className='container d-flex align-items-center justify-content-center mt-5'>
                    <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                    
                </div>
    </div>
  );
};

export default SearchProductPage;
